import React from 'react';

const Shimmer = () => (
  <div className="shimmer_wrapper">
    <div className="shimmer"></div>
  </div>
);

export default Shimmer;
